// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".store-apps{\n    display:flex;\n    flex-direction: row;\n    justify-content:center;\n}\n\n.google-play-badge{\n    width:auto;\n    height:60px;\n}\n\n.app-store-badge{\n    width:auto;\n    height:41px;\n    margin:10px;\n}\n", ""]);
// Exports
module.exports = exports;
